// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import LookupPictureModifiedAfterRequestModel from '../../model/lookup-picture-modified-after-request-model';
import LookupPictureModifiedAfterRequestDTO from '../dto/lookup-picture-modified-after-request-dto';

export default abstract class LookupPictureModifiedAfterRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<LookupPictureModifiedAfterRequestDTO>) {
    super();
    if (data) {
      this.modifiedDate = data.modifiedDate;
    }
  }
  /**
  * @type {date-time}
  */
  'modifiedDate'?: string;

  static toModel(dto: DeepPartial<LookupPictureModifiedAfterRequestDTO>): LookupPictureModifiedAfterRequestModel;
  static toModel(dto: DeepPartial<LookupPictureModifiedAfterRequestDTO> | undefined | null): LookupPictureModifiedAfterRequestModel | undefined;
  static toModel(dto: DeepPartial<LookupPictureModifiedAfterRequestDTO> | undefined | null): LookupPictureModifiedAfterRequestModel | undefined {
    return dto ? new LookupPictureModifiedAfterRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<LookupPictureModifiedAfterRequestModel> | LookupPictureModifiedAfterRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'modifiedDate': unwrapped.modifiedDate,
    } as LookupPictureModifiedAfterRequestDTO;
  }
}
